import styled from 'styled-components';
import GrommetTheme from '../../styles/GrommetTheme';

const LAYOUT_BP = 'large';
const ARROW_COLOR = GrommetTheme.global.colors['accent-2'];
const ARROW_COLOR__HOVER = GrommetTheme.global.colors['accent-1'];
const DOT_COLOR__INACTIVE = GrommetTheme.global.colors['dark-1'];
const DOT_COLOR__ACTIVE = GrommetTheme.global.colors['brand'];

export const StyledHeroCarousel = styled.section`
  width: 100%;
  overflow: hidden;

  .carousel-frame {
    position: relative;
  }

  // Buttons
  // Raw CSS selectors because these are generated by the carousel framework

  .carousel__back-button,
  .carousel__next-button {
    @media ${({ theme }) => theme.custom.layouts[`below_${LAYOUT_BP}`]} {
      display: none;
    }

    position: absolute;
    width: var(--outerGutter);
    height: var(--outerGutter);

    top: 50%;
    transform: translateY(-50%);

    bottom: 0;
    background: transparent;
    border: none;
    border-radius: 0px;
    &:disabled {
      display: none;
    }

    svg {
      width: 100%;
      height: 100%;
      max-width: 24px;
    }

    svg path {
      stroke: ${ARROW_COLOR};
      transition: stroke 0.5s ease;
    }

    &:hover {
      svg path {
        stroke: ${ARROW_COLOR__HOVER};
      }
    }
  }

  /* Specific Buttons */

  .carousel__back-button {
    left: 0;
    
    @media ${({ theme }) => theme.custom.layouts.above_xlarge} {
      left: calc(50% - var(--breakpointWidth) / 2);
    }

    svg {
      transform: rotate(180deg);
    }
  }

  .carousel__next-button {
    right: 0;
    
    @media ${({ theme }) => theme.custom.layouts.above_xlarge} {
      right: calc(50% - var(--breakpointWidth) / 2);
    }
  }

  /* Dots */

  .hero-carousel__dots {
    /* position: absolute; */
    /* bottom: 0;
    width: 100%;
    left: 0;
    right: 0; */
  }

  .carousel {
    &__dot-group {
      padding: 20px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      width: auto;
      align-self: center;
      min-width: 120px;
    }
    &__dot {
      flex: 0 1 40px;

      border: none;
      background-color: transparent;

      & > span {
        width: 15px;
        height: 15px;
        display: block;
        border-radius: 50%;
        background-color: ${DOT_COLOR__INACTIVE};
        transition: all 0.3s ease;
        &:hover {
          background-color: ${DOT_COLOR__ACTIVE};
        }
      }

      &--selected {
        & > span {
          background-color: ${DOT_COLOR__ACTIVE};
        }
      }
    }
  }
`;


export const StyledHeroCarouselItem = styled.div`
  position: relative;
  @media ${({ theme }) => theme.custom.layouts[`above_${LAYOUT_BP}`]} {
    max-height: 600px;
  }

  .hero-carousel-item__image {
    @media ${({ theme }) => theme.custom.layouts[`above_${LAYOUT_BP}`]} {
      filter: brightness(0.3);
      width: 100%;
    }
  }
  .hero-carousel-item__content {
    @media ${({ theme }) => theme.custom.layouts[`below_${LAYOUT_BP}`]} {
      padding: 40px var(--outerGutter) 0px;
    }

    @media ${({ theme }) => theme.custom.layouts[`above_${LAYOUT_BP}`]} {
      ${({ theme }) => theme.custom.helpers.LayoutContainer``};
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      width: 100%;
      padding-left: var(--outerGutter);
      padding-right: var(--outerGutter);
    }
  }

  .hero-carousel-item__content-inner {
    @media ${({ theme }) => theme.custom.layouts[`above_${LAYOUT_BP}`]} {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 100%;
      max-width: 560px;
      padding-left: 40px;
    }
  }

  // Content children
  .hero-carousel-item__button-icon {
    width: 40px;
    height: 40px;
    padding-right: 10px;

    @media ${({ theme }) => theme.custom.layouts[`below_${LAYOUT_BP}`]} {
      display: none;
    }
  }
  .hero-carousel-item__title,
  .hero-carousel-item__body * {
    @media ${({ theme }) => theme.custom.layouts[`above_${LAYOUT_BP}`]} {
      color: ${({ theme }) => theme.global.colors['light-1']};
    }
  }
  .hero-carousel-item__title {
    @media ${({ theme }) => theme.custom.layouts[`below_${LAYOUT_BP}`]} {
      font-size: 28px;
      line-height: 32px;
    }
    padding-bottom: 20px;
  }
  .hero-carousel-item__body {
    padding-bottom: 30px;
  }
`;